jQuery( document ).ready( function( $ ) {
	console.log( "Common jQuery script loaded." );
});
